import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { noticeService, calendarService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as noticesActions from './actions';

export function fetchNotice(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_ONE),
    mergeMap(({ payload }) => {
      return noticeService.getNoticeById(payload)
        .pipe(
          map(res => noticesActions.fetchNoticeSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchNotices(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_COLLECTION),
    mergeMap(({ payload }) => {
      return noticeService.getNotices(payload)
        .pipe(
          map(res => noticesActions.fetchNoticesSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function saveFavorite(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_FAVORITE),
    mergeMap(({ payload }) => {
      return calendarService.saveFavorite(payload)
        .pipe(
          map(res => noticesActions.saveFavoriteSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function removeFavorite(action$) {
  return action$.pipe(
    ofType(actionTypes.REMOVE_FAVORITE),
    mergeMap(({ payload }) => {
      return calendarService.removeFavorite(payload)
        .pipe(
          map(res => noticesActions.removeFavoriteSuccess(payload)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function getFavorites(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_FAVORITES),
    mergeMap(({ payload }) => {
      return calendarService.getFavorites(payload)
        .pipe(
          map(res => noticesActions.getFavoritesSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function saveNoticesReadPost(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_READ_POST),
    mergeMap(({ payload }) => {
      return noticeService.saveReadPost(payload)
        .pipe(
          map(res => noticesActions.saveNoticesReadPostSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function getNoticesReadPosts(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_READ_POSTS),
    mergeMap(({ payload }) => {
      return noticeService.getReadPosts(payload)
        .pipe(
          map(res => noticesActions.getNoticesReadPostsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
